import { useState } from "react";
import { RiCloseLargeLine } from "react-icons/ri";
import { motion, AnimatePresence } from "framer-motion";
import { changeLanguage } from "../scripts/GoogleTranslate.js";

import data from "../data/data.json";

import { TiThMenu } from "react-icons/ti";

import "../styles/navbar.scss"; // Asumiendo que guardas el CSS en un archivo separado

function NavBar({ tab, setTab, getTabPath, user, setLanguage, textContent }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const navLinks = textContent?.navbar?.navLinks || [];

  const navLinksUser = textContent?.navbar?.navLinksUser || [];

  const navLinksCompany = textContent?.navbar?.navLinksCompany || [];


  let navLinksToUse = navLinks;
  if (user === "user") {
    navLinksToUse = navLinksUser;
  } else if (user === "company") {
    navLinksToUse = navLinksCompany;
  }

  // 2. Creamos una función manejadora para no repetir la lógica del onClick.
  const handleNavClick = (tabId) => {
    setTab(tabId);
    window.scrollTo(0, 0);
    // Si la navegación móvil está abierta, la cerramos.
    if (mobileNavOpen) {
      setMobileNavOpen(false);
    }
  };

  const handleBookingClick = () => {
    const urlToUse =
      user === "user" ? data.externalLinks.bookingURL : data.externalLinks.bookingURL;

    window.open(urlToUse, "_blank");
    if (mobileNavOpen) {
      setMobileNavOpen(false);
    }
  };

  // 3. Creamos una función que renderiza los enlaces para no repetir el JSX.
  const renderNavLinks = () => (
    <>
      {navLinksToUse.map((link) => (
        <AnimatePresence mode="popLayout">
        <motion.li key={link.id} layout>
          <a
            href={getTabPath(link.id)}
            className={`tab-link ${tab === link.id ? "active" : ""} ${link.id === 0 ? "notranslate" : ""}`}
            onClick={(e) => {
              e.preventDefault(); // Prevenimos el comportamiento por defecto del <a>
              handleNavClick(link.id);
            }}
          >
            {link.label}
          </a>
        </motion.li>
        </AnimatePresence>
      ))}
    </>
  );

  return (
    <>
      {/* --- Barra de Navegación Principal (Desktop) --- */}
      <header className="main-navbar">
        <motion.nav layout transition={{ duration: 0.3, ease: "easeInOut" }}>
          <img
            onClick={() => handleNavClick(0)}
            src="minLogo.png"
            alt="Elite Logo"
            draggable="false"
            className="nav-logo"
          />
          <motion.ul className="tabs" layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}>{renderNavLinks()}</motion.ul>

          <select onChange={(e) => setLanguage(e.target.value)} defaultValue="en">
            <option value="en" >English</option>
            <option value="es" >Español</option>
          </select>

          <button className="tab-button" onClick={handleBookingClick}>
            {textContent?.navbar?.btn}
          </button>
        </motion.nav>
      </header>

      {/* --- Botón para abrir el menú móvil --- */}
      <button
        className="mobile-nav-toggle"
        aria-controls="mobile-navbar"
        aria-expanded={mobileNavOpen}
        onClick={() => setMobileNavOpen(!mobileNavOpen)}
      >
        {mobileNavOpen ? <RiCloseLargeLine /> : <TiThMenu />}
      </button>

      {/* --- Barra de Navegación Móvil --- */}
      {/* 6. Usamos una clase condicional para controlar la visibilidad y animaciones con CSS */}
      <div
        id="mobile-navbar"
        className={`mobile-navbar ${mobileNavOpen ? "is-open" : ""}`}
      >
        <nav className="menu">
          {/* La lógica del botón de cierre ahora está en el toggle de arriba */}
          <ul>{renderNavLinks()}</ul>
          <select onChange={(e) => setLanguage(e.target.value)} defaultValue="en">
            <option value="en" >English</option>
            <option value="es" >Español</option>
          </select>
          <button className="tab-button" onClick={handleBookingClick}>
            {textContent?.navbar?.btn}
          </button>
        </nav>
      </div>
    </>
  );
}

export default NavBar;
